import React from 'react';
import './jh.css';

const produtos = [
  { nome: 'Paralelepípedo', imagem: '/Images/Parceiros/sites/Jh/paralelepipedo1.png' },
  { nome: 'Brita 19', imagem: '/Images/Parceiros/sites/Jh/Brita19.png' },
  { nome: 'Brita 25', imagem: '/Images/Parceiros/sites/Jh/Brita25.png' },
  { nome: 'Brita 50', imagem: '/Images/Parceiros/sites/Jh/Brita50.png' },
  { nome: 'Brita 75', imagem: '/Images/Parceiros/sites/Jh/Brita75.png' },
  { nome: 'Areia Grossa', imagem: '/Images/Parceiros/sites/Jh/AreiaGrossa.png' },
  { nome: 'Areia Fina', imagem: '/Images/Parceiros/sites/Jh/AreiaFina.png' },
  { nome: 'Rachão', imagem: '/Images/Parceiros/sites/Jh/Rachao.png' },
  { nome: 'Meio-Fio', imagem: '/Images/Parceiros/sites/Jh/meio-fio.png' },
  { nome: 'Pó de Pedra', imagem: '/Images/Parceiros/sites/Jh/PodePedra.png' },
  // { nome: 'Areia Grossa Paraíba', imagem: '/Images/Parceiros/sites/Jh/produtos/paralelepipedo1.png' },
  { nome: 'Cascalhinho', imagem: '/Images/Parceiros/sites/Jh/Cascalhinho.png' },
  { nome: 'Barro', imagem: '/Images/Parceiros/sites/Jh/Barro.png' },
  { nome: 'Terra Vegetal', imagem: '/Images/Parceiros/sites/Jh/Terra-Vegetal.png' },
  // { nome: 'Areia Miritiba', imagem: '/Images/Parceiros/sites/Jh/produtos/paralelepipedo1.png' }
];

function Produtosjh() {
  return (
    <section id="produtos-jh">
      <div className="container">
        <div className="row justify-content-center text-center mb-4">
          <div className="col-12">
            <h1 className="titulo-produtos-jh">
              Clique no produto desejado para conversar conosco pelo WhatsApp e consultar preços, entrega e disponibilidade.
            </h1>
          </div>
        </div>

        <div className="row">
          {produtos.map((produto, index) => (
            <div key={index} className="col-12 col-md-6 mb-4 d-flex flex-column align-items-center text-center">
              <a
                href="https://api.whatsapp.com/send?phone=5581988823062"
                target="_blank"
                rel="nofollow"
              >
                <img
                  src={produto.imagem}
                  className="zoom-img produto-img"
                  alt={produto.nome}
                />
              </a>
              <p className="nome-produto">{produto.nome}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Produtosjh;

